/* 设置环境 生产： prod  测试： test；默认兜底 prod，由 --my-env(build)/MY_ENV(dev) 注入 */
const BXEVN = process.env.BXEVN || "prod"

const VERSION = "1.0.0";

/* CMS环境 */
const JAVAHOSTURL = {
    test: "https://gatewayusertest.gaosiedu.com/",
    prod: "https://gatewayuser.gaosiedu.com/",
  };
/* Net业务环境 */
const NETHOSTURL = {
    test: "https://gatewaytest.gaosiedu.com/",
    prod: "https://gateway.gaosiedu.com/",
  };

/* Passport 环境 */
const WWWURL = {
    test: "https://qingke-private-test--www.ghost.aixuexi.com",
    prod: "https://www.aixuexi.com",
  };

/* 认证服务环境 */
const AUTHHOSTURL = {
    test: "https://authtest.gaosiedu.com",
    prod: "https://auth.gaosiedu.com",
  };

/* 好爱学环境 */
const HAOAIXUEURL = {
    test: "https://sq-private-dev2_haoaixueedu.ghost.aixuexi.com/",
    prod: "https://www.haoaixueedu.com/",
  };

  module.exports = {
    VERSION,
    BXEVN,
    JAVAHOSTURL,
    NETHOSTURL,
    WWWURL,
    AUTHHOSTURL,
    HAOAIXUEURL
  };



//////////////////
// WEBPACK FOOTER
// /resource/code/pmn3myn9-dev_guanwang_1.5.422/packages/gaosiweb-common/js/default.js
// module id = Of5G
// module chunks = 55